'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logEvent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Logging of editor interactions to sumo per this spec:
                                                                                                                                                                                                                                                                   * https://docs.google.com/spreadsheets/d/1SPRq49OVP3e-YCKbLhw5hCNaPnftQvVphTm6mutV8eQ/edit#gid=1243181821
                                                                                                                                                                                                                                                                   */

var _hudlBase = require('hudl-base');

var _hudlBase2 = _interopRequireDefault(_hudlBase);

var _logValues = require('../shared/logging/log-values');

var _loggingUtil = require('./logging-util');

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 05/2017 Prevent console errors when calling play/pause in Chrome. These errors have no other impact
 * on playback. The play promise is encapsulated within THEOplayer and JwPlayer, so we must catch
 * these on window. Remove once the Chromium bug is actually fixed:
 * https://bugs.chromium.org/p/chromium/issues/detail?id=593273
 */
window.addEventListener('unhandledrejection', function (e) {
  if (e.reason && e.reason.toString() === 'AbortError: The play() request was interrupted by a call to pause().') {
    // Prevent a console error.
    e.preventDefault();
  }
});

var logEvent = function logEvent(properties) {
  var pascalProperties = (0, _loggingUtil.generateObjectWithPascalCaseKeys)(properties);

  // Log to sumologic
  /* eslint-disable no-new */
  var sumoLog = new _hudlBase2.default.UsageLogEvent({
    logger: '',
    logOnUnload: false,
    data: _extends({}, (0, _omit2.default)(pascalProperties, ['Interaction', 'Func']), {
      Func: pascalProperties.Func.replace(/\s/g, ''), // No spaces for sumo logs
      Op: _logValues.FEED_CONTENT
    })
  });
  sumoLog.log();
  /* eslint-enable no-new */
};

exports.logEvent = logEvent;